import React, { useState } from "react";
import ModalHeader from "../../Modal/ModalHeader/ModalHeader";
import StepOne from "./Steps/Step1";
import StepTwo from "./Steps/Step2";
import StepThree from "./Steps/Step3";
import StepFour from "./Steps/Step4";
import StepFive from "./Steps/Step5";
import StepSix from "./Steps/Step6";
import StepSeven from "./Steps/step7";
import StepHeight from "./Steps/step8";
import StepNine from "./Steps/step9";

export default function HoteTree(props) {
    const [step, setStep] = useState(1);
    const steps = ["Type de logement", "Fréquence de mise en location", "Sous-traitance", "Durée des séjours", "Période de location", "Profil de locataires", 'Habitudes', "Avis", "Conséquence"]

    function prevStep() {
        setStep(step - 1);
    }

    function nextStep() {
        setStep(step + 1);
    }

    function getStep() {
        switch (step) {
            case 1:
                return <StepOne handleChange={props.handleChange} datas={props.datas} prev={props.prev} next={nextStep} />
            case 2:
                return <StepTwo handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={nextStep} />
            case 3:
                return <StepThree handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={nextStep} />
            case 4:
                return <StepFour handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={nextStep} />
            case 5:
                return <StepFive handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={nextStep} />
            case 6:
                return <StepSix handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={nextStep} />
            case 7:
                return <StepSeven handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={nextStep} />
            case 8:
                return <StepHeight handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={nextStep} />
            case 9:
                return <StepNine handleChange={props.handleChange} datas={props.datas} prev={prevStep} next={props.next} />
        }
    }

    return (
        <>
            <ModalHeader stepper steps={steps} activeStep={step} />
            {
                getStep()
            }
        </>
    )
}